var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "collapse", attrs: { id: "collapseAddUser" } }, [
      _c("div", { staticClass: "margin-20" }),
      _vm._v(" "),
      _c("form", [
        _c("div", { staticClass: "panel panel-grey no-margin" }, [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "form-horizontal" },
              [
                _c("create-user", { ref: "createUser" }),
                _vm._v(" "),
                _c("div", { staticClass: "alert alert-info m-b-none" }, [
                  _vm._v(
                    "\n              We'll send an e-mail to the new booking agent where they will be able to set their password.\n            "
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel-footer text-right" },
            [
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-sm btn-info",
                  attrs: { type: "submit", click: _vm.handleAddUserCallback },
                },
                [_vm._v("\n            Add Booking Agent\n          ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-sm btn-primary",
        attrs: {
          role: "button",
          "data-toggle": "collapse",
          href: "#collapseAddUser",
          "aria-expanded": "false",
          "aria-controls": "collapseAddUser",
        },
      },
      [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Add Booking Agent\n  ")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }